export default __webpack_public_path__ + "static/media/NHLFantasyPWRSBanner.e43e0e0a.png";